import { render, staticRenderFns } from "./SoftwareForms.vue?vue&type=template&id=6cecf2a4"
import script from "./SoftwareForms.vue?vue&type=script&lang=js"
export * from "./SoftwareForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports